import { UserEntity } from './interfaces';
import { Core } from '../core';

export class UserInviteDto {
  email: string | undefined = undefined;
  permission_id: string | undefined = undefined;
}

export const UsersStore = Core.Stores.create<UserEntity>('/users');
